(function () {
  /////// Toggle the navbar's solid (white) state once the page is scrolled.
  const SCROLL_THRESHOLD = 50;
  const SCROLLED_CLASS = 'navbar-is-scrolled';

  const body = document.body;
  let ticking = false;

  function updateNavbarState() {
    if (window.scrollY > SCROLL_THRESHOLD) {
      body.classList.add(SCROLLED_CLASS);
    } else {
      body.classList.remove(SCROLLED_CLASS);
    }
    ticking = false;
  }

  function onScroll() {
    if (!ticking) {
      window.requestAnimationFrame(updateNavbarState);
      ticking = true;
    }
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  updateNavbarState();
})();
